
export class Trigger {
  data: {
    firstName: string,
    lastName: string,
    type: number,
  };
  isApproaching: boolean;
  applicationId: number;
  mainObjectId: number;
  objectId: number;
  severity: number;
  triggerCategory: number;
  triggerType: number;
  value: number;

}
